import { Box, HStack, Text, VStack } from "@chakra-ui/react";

interface Props {
  mode?: "light" | "dark";
}

export default function Footer({ mode = "dark" }: Props) {
  return (
    <VStack
      p={4}
      spacing={8}
      color={mode === "dark" ? "white" : "gray.700"}
      align="left"
    >
      <Text>Copyright (c) Tanyoung Kim. Private use only.</Text>
      <Box lineHeight="1.6em">
        <Text whiteSpace="nowrap">🛠️ Try my knitting tools!</Text>
        <a
          href="https://tanyoknits.github.io/truly-even/"
          target="_blank"
          rel="noreferrer"
        >
          <Text variant="link">Truly Even Stitch Increase or Decrease</Text>
        </a>
        <a
          href="https://tanyoknits.github.io/button-band/"
          target="_blank"
          rel="noreferrer"
        >
          <Text variant="link">Just Right Stitch Pick Up</Text>
        </a>
      </Box>
      <Box lineHeight="1.6em">
        <Text whiteSpace="nowrap">🔗 Find me here! </Text>
        <HStack spacing={2}>
          <a
            href="https://www.ravelry.com/people/tanyoknits"
            target="_blank"
            rel="noreferrer"
          >
            <Text variant="link">Raverly</Text>
          </a>
          <a
            href="https://twitter.com/tanyoknits"
            target="_blank"
            rel="noreferrer"
          >
            <Text variant="link">Twitter</Text>
          </a>
          <a
            href="https://www.instagram.com/tanyoknits/"
            target="_blank"
            rel="noreferrer"
          >
            <Text variant="link">Instagram</Text>
          </a>
        </HStack>
      </Box>
    </VStack>
  );
}

// Copying the whole or parts
// of patterns on this website without a written permision is prohibited.
